import { forwardRef, useEffect, useState } from "react";
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { toast } from "sonner";

export const CARD_W = 270, CARD_H = 428; // 54 × 85.6 mm (ID-1 portrait)
export const BRANDS = {
  hungerstation: { label: "هنقرستيشن", text: "HUNGER\nSTATION", primary: "#FFD200", secondary: "#2BB5E8", onPrimary: "#2b2b2b", onSecondary: "#ffffff", ink: "#3a2a1a" },
  keeta: { label: "كيتا", text: "Keeta", primary: "#FFE41F", secondary: "#11CC9A", onPrimary: "#1f1f1f", onSecondary: "#ffffff", ink: "#111111" },
  ninja: { label: "نينجا", text: "NINJA", primary: "#4A1D7A", secondary: "#F9C80E", onPrimary: "#ffffff", onSecondary: "#2b2b2b", ink: "" },
  custom: { label: "شركة أخرى", text: "COMPANY", primary: "#1E3A8A", secondary: "#F59E0B", onPrimary: "#ffffff", onSecondary: "#1f1f1f", ink: "" },
};
export const brandTheme = (cfg, key) => {
  const k = BRANDS[key] ? key : BRANDS[cfg?.brand] ? cfg.brand : "hungerstation";
  return { ...BRANDS[k], ...((cfg?.brands || {})[k] || {}), key: k };
};
const Logo = ({ t, size, color, urlOf }) => (t.logo_id && urlOf
  ? <div style={{ display: "flex", justifyContent: "center" }}><img src={urlOf(t.logo_id)} alt="" crossOrigin="anonymous" style={{ height: size * 1.9, maxWidth: 200 }} /></div>
  : <div style={{ fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif", fontWeight: 900, fontSize: (t.text || "").includes("\n") ? size : size * 1.3, lineHeight: 0.92, color: t.ink || color, letterSpacing: -0.5, textAlign: "center", direction: "ltr", whiteSpace: "pre-line" }}>{t.text}</div>);
export const cardUrl = (token) => `${window.location.origin}/card/${token}`;

const Side = forwardRef(({ children, bg, testid, flat }, ref) => (
  <div ref={ref} data-testid={testid} dir="rtl" style={{ width: CARD_W, height: CARD_H, background: bg, position: "relative", overflow: "hidden", borderRadius: flat ? 0 : 12, boxShadow: flat ? "none" : "0 6px 20px rgba(0,0,0,.15)", flexShrink: 0 }}>{children}</div>
));

export const CardFront = forwardRef(({ card, photoUrl, flat, cfg, urlOf }, ref) => {
  const t = brandTheme(cfg, card.brand);
  return (
    <Side ref={ref} bg={t.primary} testid="rider-card-front" flat={flat}>
      <div style={{ position: "absolute", top: 14, left: 89, width: 92, height: 18, border: `2px solid ${t.onPrimary}`, opacity: 0.6, borderRadius: 6 }} />
      <div style={{ position: "absolute", top: 52, left: 71, width: 128, height: 156, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
        {photoUrl ? <div style={{ width: "100%", height: "100%", backgroundImage: `url("${photoUrl}")`, backgroundSize: "cover", backgroundPosition: "center" }}><img src={photoUrl} alt="" crossOrigin="anonymous" style={{ display: "none" }} /></div> : <span style={{ color: "#bbb", fontSize: 12 }}>الصورة</span>}
      </div>
      <div style={{ position: "absolute", top: 214, left: 10, right: 10, textAlign: "center", fontWeight: 800, fontSize: (card.name || "").length > 24 ? 11.5 : 13, lineHeight: 1.45, color: t.onPrimary }}>
        <div data-testid="rider-card-name">الاسم / {card.name || "—"}</div>
        <div>رقم الهوية : <span dir="ltr">{card.id_number || "—"}</span></div>
        <div>رقم المعرف / <span dir="ltr">{card.rider_code || "—"}</span></div>
        <div data-testid="rider-card-phone">الجوال / <span dir="ltr">{card.phone || "—"}</span></div>
      </div>
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 110, overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 10, left: "-25%", width: "150%", height: 70, borderRadius: "50%", background: t.secondary }} />
        <div style={{ position: "absolute", top: 45, left: 0, right: 0, bottom: 0, background: t.secondary }} />
      </div>
      <div style={{ position: "absolute", bottom: 14, left: 0, right: 0 }} data-testid="rider-card-brand"><Logo t={t} size={33} color={t.onSecondary} urlOf={urlOf} /></div>
    </Side>
  );
});

export const CardBack = forwardRef(({ cfg, token, logoUrl, flat, brand, urlOf }, ref) => {
  const t = brandTheme(cfg, brand);
  const [qr, setQr] = useState("");
  useEffect(() => { if (token) QRCode.toDataURL(cardUrl(token), { margin: 1, width: 220 }).then(setQr).catch(() => {}); }, [token]);
  return (
    <Side ref={ref} bg={t.secondary} testid="rider-card-back" flat={flat}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 135, overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 100, background: t.primary }} />
        <div style={{ position: "absolute", top: 62, left: "-25%", width: "150%", height: 70, borderRadius: "50%", background: t.primary }} />
      </div>
      <div style={{ position: "absolute", top: 26, left: 0, right: 0 }}><Logo t={t} size={30} color={t.onPrimary} urlOf={urlOf} /></div>
      <div style={{ position: "absolute", top: 138, left: 10, right: 10, textAlign: "center", color: t.onSecondary, fontWeight: 800, fontSize: 12.5, lineHeight: 1.7, whiteSpace: "pre-line" }}>
        {cfg.emergency_text}
        <div>على الرقم / <span dir="ltr">{cfg.phone}</span></div>
        <div>البريد الالكتروني</div>
        <div dir="ltr" style={{ fontWeight: 600, fontSize: 12 }}>{cfg.email}</div>
      </div>
      <div style={{ position: "absolute", top: 272, left: 8, right: 8, display: "flex", alignItems: "center", gap: 6 }}>
        <div style={{ flex: 1, textAlign: "center", color: t.onSecondary, fontSize: 9.5, fontWeight: 700, lineHeight: 1.5 }}>{cfg.company_label}<br />{cfg.company_name}</div>
        {logoUrl && <img src={logoUrl} alt="" crossOrigin="anonymous" style={{ height: 44, maxWidth: 80 }} />}
      </div>
      <div style={{ position: "absolute", bottom: 10, left: 10, width: 92, height: 92, background: "#fff", padding: 3 }}>{qr && <img src={qr} alt="QR" style={{ width: "100%", height: "100%" }} data-testid="rider-card-qr" />}</div>
      <div style={{ position: "absolute", bottom: 22, right: 10, width: 140, color: t.onSecondary, fontWeight: 800, fontSize: 12, textAlign: "center" }}>{cfg.qr_note}</div>
    </Side>
  );
});

const snap = async (el) => (await html2canvas(el, { scale: 5, useCORS: true, backgroundColor: null })).toDataURL("image/png");
const snapJpg = async (el) => (await html2canvas(el, { scale: 5, useCORS: true, backgroundColor: "#ffffff" })).toDataURL("image/jpeg", 0.95);
// A4 sheet: 3×3 cards at real ID size; back page mirrors columns so both faces align on long-edge duplex.
const CW = 54, CH = 85.6, GX = 8, GY = 6, COLS = 3, ROWS = 3;
export const SHEET = COLS * ROWS;
const OX = (210 - (COLS * CW + (COLS - 1) * GX)) / 2, OY = (297 - (ROWS * CH + (ROWS - 1) * GY)) / 2;
const slot = (i, back) => { const c = i % COLS, r = Math.floor(i / COLS); return [OX + (back ? COLS - 1 - c : c) * (CW + GX), OY + r * (CH + GY)]; };
export const newCardPDF = () => new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
const sheetImgs = async (pairs) => {
  const out = [];
  for (const [f, b] of pairs) out.push([await snapJpg(f), await snapJpg(b)]);
  return out;
};
export const addCardSheet = async (pdf, pairs) => {
  const imgs = await sheetImgs(pairs);
  const idx = imgs.length === 1 ? [1] : imgs.map((_, k) => k);
  for (const side of [0, 1]) {
    if (pdf.__used) pdf.addPage("a4", "portrait");
    pdf.__used = true;
    pdf.setDrawColor(210); pdf.setLineWidth(0.1);
    imgs.forEach((p, k) => { const [x, y] = slot(idx[k], side === 1); pdf.addImage(p[side], "JPEG", x, y, CW, CH); pdf.rect(x, y, CW, CH); });
  }
};
export const downloadCardPNG = async (front, back, name) => {
  try {
    for (const [el, side] of [[front, "امام"], [back, "خلف"]]) {
      const a = document.createElement("a"); a.href = await snap(el); a.download = `بطاقة-${name || "مندوب"}-${side}.png`; a.click();
    }
    return true;
  } catch { toast.error("تعذّر إنشاء الصورة"); return false; }
};
// Direct print on A4 at real ID size: page 1 = front, page 2 = back at the same spot (duplex).
export const printCardDirect = async (front, back) => {
  try {
    const [[fi, bi]] = await sheetImgs([[front, back]]);
    const [x, y] = slot(1, false);
    const page = (src) => `<div class="pg"><img src="${src}" style="left:${x}mm;top:${y}mm"/></div>`;
    const f = document.createElement("iframe");
    f.style.cssText = "position:fixed;width:0;height:0;border:0;right:0;bottom:0";
    document.body.appendChild(f);
    const d = f.contentDocument;
    d.open();
    d.write(`<!doctype html><html><head><title>بطاقة</title><style>@page{size:A4 portrait;margin:0}html,body{margin:0;padding:0}.pg{position:relative;width:210mm;height:296mm;overflow:hidden;page-break-after:always;break-after:page}.pg:last-child{page-break-after:auto;break-after:auto}img{position:absolute;width:${CW}mm;height:${CH}mm;outline:0.1mm solid #d2d2d2}</style></head><body>${page(fi)}${page(bi)}</body></html>`);
    d.close();
    await new Promise((r) => setTimeout(r, 500));
    f.contentWindow.focus();
    f.contentWindow.print();
    setTimeout(() => f.remove(), 60000);
    return true;
  } catch { toast.error("تعذّرت الطباعة"); return false; }
};
export const printCardPDF = async (front, back, name) => {
  try { const p = newCardPDF(); await addCardSheet(p, [[front, back]]); p.save(`بطاقة-${name || "مندوب"}.pdf`); return true; }
  catch { toast.error("تعذّر إنشاء ملف PDF"); return false; }
};
